/* @flow */
import AppleImage from 'assets/images/apple.svg';
import BellImage from 'assets/images/bell.svg';
import BoxSelect from 'components/BoxSelect.jsx';
import BoxSelectItem from 'components/BoxSelectItem.jsx';
import HeartImage from 'assets/images/heart.svg';
import PencilImage from 'assets/images/pencil.svg';
import React from 'react';
import { Roles } from 'user/UserConstants';
import SettingsActions from 'actions/SettingsActions';

class RolePicker extends React.Component {
  static propTypes = {
    onSelect: React.PropTypes.func.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  state = {
    hover: null,
    showAdminOption: false,
  };

  componentDidMount() {
    const onGeoReceived = (geo) => {
      if (!geo.country_code || geo.country_code === 'US') {
        this.setState({ showAdminOption: true });
      }
    };

    SettingsActions.getGeo()
      .then(onGeoReceived);
  }

  render() {
    return (
      <BoxSelect title="Tell us about yourself">
        <BoxSelectItem
          label="I’m a teacher"
          className="RolePicker-button--teacher"
          eventElementName="RolePicker-button--teacher"
          icon={AppleImage}
          action={() => this.props.onSelect(Roles.teacher)}>
          Teacher, coach, club adviser, organizer, etc.
        </BoxSelectItem>
        <BoxSelectItem
          label="I’m a student"
          className="RolePicker-button--student"
          eventElementName="RolePicker-button--student"
          icon={PencilImage}
          action={() => this.props.onSelect(Roles.student)}>
          Student in a class, member of a sports team, club participant, etc.
        </BoxSelectItem>
        <BoxSelectItem
          label="I’m a parent"
          className="RolePicker-button--parent"
          eventElementName="RolePicker-button--parent"
          icon={HeartImage}
          action={() => this.props.onSelect(Roles.parent)}>
          Parent or guardian
        </BoxSelectItem>
        {this.state.showAdminOption &&
          <BoxSelectItem
            label="I’m an administrator"
            className="RolePicker-button--admin"
            eventElementName="RolePicker-button--admin"
            icon={BellImage}
            action={() => this.context.router.push('/setup/admin_role')}>
            Superintendent, principal, tech coordinator, etc.
          </BoxSelectItem>
        }
      </BoxSelect>
    );
  }
}

export default RolePicker;



// WEBPACK FOOTER //
// ./src/components/RolePicker.jsx